import { GotFocusEventArgs as GotFocusEventArgs_internal } from "./GotFocusEventArgs";
var IgrGotFocusEventArgs = /** @class */ /*@__PURE__*/ (function () {
    function IgrGotFocusEventArgs() {
        this._implementation = this.createImplementation();
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    }
    IgrGotFocusEventArgs.prototype.createImplementation = function () {
        return new GotFocusEventArgs_internal();
    };
    Object.defineProperty(IgrGotFocusEventArgs.prototype, "i", {
        /**
         * @hidden
         */
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    IgrGotFocusEventArgs.prototype.onImplementationCreated = function () {
    };
    IgrGotFocusEventArgs.prototype._provideImplementation = function (i) {
        this._implementation = i;
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    };
    return IgrGotFocusEventArgs;
}());
export { IgrGotFocusEventArgs };
//# sourceMappingURL=igr-got-focus-event-args.js.map
